export const Permissions = {
	CanViewSocialPosts: "CanViewSocialPosts",
	CanSubmitSocialPosts: "CanSubmitSocialPosts",
	CanEditOthersSocialPosts: "CanEditOthersSocialPosts",
	CanModerateReportedSocialPosts: "CanModerateReportedSocialPosts",
	CanScheduleSocialPosts: "CanScheduleSocialPosts",
	CanSubmitObservations: "CanSubmitObservations",
	CanViewEditObservationForms: "CanViewEditObservationForms",
	CanViewObservationReporting: "CanViewObservationReporting",
	CanManageAnnouncements: "CanManageAnnouncements",
	CanManagePages: "CanManagePages",
	CanViewEditEvents: "CanViewEditEvents",
	CanViewEditHomepageContent: "CanViewEditHomepageContent",
	CanViewEditNavigation: "CanViewEditNavigation",
	CanViewAnalytics: "CanViewAnalytics",
	CanViewUserAnalytics: "CanViewUserAnalytics",
	CanViewEditPeople: "CanViewEditPeople",
	CanViewEditLocations: "CanViewEditLocations",
	CanViewEditGroups: "CanViewEditGroups",
	CanViewEditUserRoles: "CanViewEditUserRoles",
	CanUploadMedia: "CanUploadMedia",
	CanManageMedia: "CanManageMedia",
	CanViewNews: "CanViewNews",
	CanManageNews: "CanManageNews",
	CanManageNotifications: "CanManageNotifications",
	CanManageHashtags: "CanManageHashtags",
	CanManageSettings: "CanManageSettings",
	CanImpersonate: "CanImpersonate"
} as const;

export type Permission = (typeof Permissions)[keyof typeof Permissions];
